import { bellIcon } from './bell/bell';
import { calculatorIcon } from './calculator/calculator';
import { carIcon } from './car/car';
import { chatIcon } from './chat/chat';
import { chevronDownIcon } from './chevron-down/chevron-down';
import { chevronLeftIcon } from './chevron-left/chevron-left';
import { chevronRightIcon } from './chevron-right/chevron-right';
import { chevronUpIcon } from './chevron-up/chevron-up';
import { closeIcon } from './close/close';
import { compassIcon } from './compass/compass';
import { cookieIcon } from './cookie/cookie';
import { copyIcon } from './copy/copy';
import { diamondIcon } from './diamond/diamond';
import { doneIcon } from './done/done';
import { editIcon } from './edit/edit';
import { enterIcon } from './enter/enter';
import { enterFullScreenIcon } from './enter-full-screen/enter-full-screen';
import { envelopeIcon } from './envelope/envelope';
import { exitIcon } from './exit/exit';
import { exitFullScreenIcon } from './exit-full-screen/exit-full-screen';
import { facebookFilledIcon } from './facebook-filled/facebook-filled';
import { fbIcon } from './facebook/facebook';
import { floorPlanIcon } from './floor-plan/floor-plan';
import { filterIcon } from './filter/filter';
import { gbpIcon } from './gbp/gbp';
import { heartIcon } from './heart/heart';
import { homeIcon } from './home/home';
import { infoIcon } from './info/info';
import { mapIcon } from './map/map';
import { pinIcon } from './pin/pin';
import { playIcon } from './play/play';
import { plusIcon } from './plus/plus';
import { preferencesIcon } from './preferences/preferences';
import { profileIcon } from './profile/profile';
import { searchIcon } from './search/search';
import { searchingIcon } from './searching/searching';
import { settingsIcon } from './settings/settings';
import { shareIcon } from './share/share';
import { sortIcon } from './sort/sort';
import { starIcon } from './star/star';
import { thumbnailsIcon } from './thumbnails/thumbnails';
import { treeIcon } from './tree/tree';
import { twitterFilledIcon } from './twitter-filled/twitter-filled';
import { minusIcon } from './minus/minus';
import { layersIcon } from './layers/layers';
import { linkedinFilledIcon } from './linkedin-filled/linkedin-filled';
import { lockIcon } from './lock/lock';
import { menuIcon } from './menu/menu';
import { optionsIcon } from './options/options';
import { userIcon } from './user/user';
import { documentIcon } from './document/document';
import { brokerIcon } from './broker/broker';
import { percentIcon } from './percent/percent';
import { checkIcon } from './check/check';
import { stopIcon } from './stop/stop';
import { questionIcon } from './question/question';
import { noPhoneIcon } from './no-phone/no-phone';
import { sheetIcon } from './sheet/sheet';
import { saveIcon } from './save/save';
import { thumbDownIcon } from './thumb-down/thumb-down';
import { mailIcon } from './mail/mail';
import { extLinkIcon } from './ext-link/ext-link';
import { calendarIcon } from './calendar/calendar';
import { noCallIcon } from './no-call/no-call';
import { downloadIcon } from './download/download';
import { phoneIcon } from './phone/phone';
import { cursorIcon } from './cursor/cursor';
import { uploadIcon } from './upload/upload';
import { checkCircleIcon } from './check-circle/check-circle';
import { startOverIcon } from './start-over/start-over';
import { supportIcon } from './support/support';
import { coinsIcon } from './coins/coins';
import { schoolIcon } from './school/school';
import { trainStationIcon } from './train-station/train-station';
import { whatsappFilledIcon } from './whatsapp-filled/whatsapp-filled';
import { broadbandIcon } from './broadband/broadband';
import { mobileIcon } from './mobile/mobile';
import { checkboxIcon } from './checkbox/checkbox';

export * from './bell/bell';
export * from './calculator/calculator';
export * from './car/car';
export * from './chat/chat';
export * from './chevron-down/chevron-down';
export * from './chevron-left/chevron-left';
export * from './chevron-right/chevron-right';
export * from './chevron-up/chevron-up';
export * from './close/close';
export * from './compass/compass';
export * from './cookie/cookie';
export * from './copy/copy';
export * from './diamond/diamond';
export * from './done/done';
export * from './edit/edit';
export * from './enter/enter';
export * from './enter-full-screen/enter-full-screen';
export * from './envelope/envelope';
export * from './exit/exit';
export * from './exit-full-screen/exit-full-screen';
export * from './facebook-filled/facebook-filled';
export * from './facebook/facebook';
export * from './filter/filter';
export * from './floor-plan/floor-plan';
export * from './gbp/gbp';
export * from './heart/heart';
export * from './home/home';
export * from './info/info';
export * from './map/map';
export * from './pin/pin';
export * from './play/play';
export * from './plus/plus';
export * from './preferences/preferences';
export * from './profile/profile';
export * from './search/search';
export * from './searching/searching';
export * from './settings/settings';
export * from './share/share';
export * from './sort/sort';
export * from './star/star';
export * from './thumbnails/thumbnails';
export * from './tree/tree';
export * from './twitter-filled/twitter-filled';
export * from './minus/minus';
export * from './layers/layers';
export * from './linkedin-filled/linkedin-filled';
export * from './lock/lock';
export * from './menu/menu';
export * from './options/options';
export * from './user/user';
export * from './document/document';
export * from './broker/broker';
export * from './percent/percent';
export * from './check/check';
export * from './no-phone/no-phone';
export * from './stop/stop';
export * from './question/question';
export * from './sheet/sheet';
export * from './save/save';
export * from './thumb-down/thumb-down';
export * from './mail/mail';
export * from './ext-link/ext-link';
export * from './calendar/calendar';
export * from './no-call/no-call';
export * from './download/download';
export * from './phone/phone';
export * from './cursor/cursor';
export * from './upload/upload';
export * from './check-circle/check-circle';
export * from './start-over/start-over';
export * from './support/support';
export * from './coins/coins';
export * from './school/school';
export * from './train-station/train-station';
export * from './whatsapp-filled/whatsapp-filled';
export * from './broadband/broadband';
export * from './mobile/mobile';
export * from './checkbox/checkbox';

export const UI_KIT_ICONS: any[] = [
  bellIcon,
  calculatorIcon,
  carIcon,
  chatIcon,
  chevronDownIcon,
  chevronLeftIcon,
  chevronRightIcon,
  menuIcon,
  chevronUpIcon,
  closeIcon,
  compassIcon,
  cookieIcon,
  copyIcon,
  diamondIcon,
  doneIcon,
  editIcon,
  enterIcon,
  enterFullScreenIcon,
  envelopeIcon,
  exitIcon,
  exitFullScreenIcon,
  facebookFilledIcon,
  fbIcon,
  floorPlanIcon,
  filterIcon,
  gbpIcon,
  heartIcon,
  homeIcon,
  infoIcon,
  mapIcon,
  pinIcon,
  playIcon,
  plusIcon,
  preferencesIcon,
  profileIcon,
  searchIcon,
  searchingIcon,
  settingsIcon,
  shareIcon,
  sortIcon,
  starIcon,
  thumbnailsIcon,
  treeIcon,
  twitterFilledIcon,
  minusIcon,
  layersIcon,
  linkedinFilledIcon,
  lockIcon,
  optionsIcon,
  userIcon,
  documentIcon,
  brokerIcon,
  percentIcon,
  checkIcon,
  stopIcon,
  questionIcon,
  noPhoneIcon,
  sheetIcon,
  saveIcon,
  thumbDownIcon,
  mailIcon,
  extLinkIcon,
  calendarIcon,
  noCallIcon,
  downloadIcon,
  phoneIcon,
  cursorIcon,
  uploadIcon,
  checkCircleIcon,
  startOverIcon,
  supportIcon,
  coinsIcon,
  schoolIcon,
  trainStationIcon,
  whatsappFilledIcon,
  broadbandIcon,
  mobileIcon,
  checkboxIcon,
];
